export const STATUS_CODE = {
  200: 200,
  400: 400,
  410: 410,
  500: 500,
  404: 404,
  401: 401,
  424: 424,
}

export const HTTP_STATUS_CODE = {
  SUCCESS: 200,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  GONE: 410,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
}
